import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'

export default createUseStyles((theme: Theme) => ({
  cardContainer: {
    boxShadow: '0px 4px 23px rgba(0, 0, 0, 0.05)',
    marginBottom: 16,
    maxWidth: '90%',
    flexBasis: 'min-content',
    margin: '0 auto',
    '&$selected': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
  },
  mainContent: {
    fontFamily: 'Roboto',
    display: 'flex',
    boxSizing: 'border-box',
    '&$desktop': {
      width: 520,
    },
  },
  bottomContent: {
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${theme.palette.grey[300]} `,
    paddingTop: 8,
    marginTop: 8,
  },
  avatar: {
    width: 44,
    height: 44,
    flexShrink: 0,
    margin: [0, 8, 0, 0],

    background: `${theme.palette.grey[300]}`,
    border: `5px solid ${theme.palette.grey[100]}`,
    boxShadow: '0px -0.5px 0.5px rgba(0, 0, 0, 0.1), 0px 0.5px 1px rgba(0, 0, 0, 0.35)',
    borderRadius: '100px',

    backgroundSize: 'contain',
    '&$desktop': {
      width: 88,
      height: 88,
      margin: [0, 0, 12],
      '&$selected': {
        boxShadow: [0, 0, 0, 2, 'inset', theme.palette.primary.main],
      },
    },
  },
  textCont: {
    marginLeft: 8,
  },
  name: {
    ...typography['Lato Emphasized 1'],
    lineHeight: '22px',
    '&$desktop': {
      width: '100%',
      margin: [0, 0, 4],
    },
  },
  roles: {
    marginBottom: 8,
    color: `${theme.palette.grey[600]}`,
    lineHeight: '22px',
  },
  nextAvailableDateCont: {
    lineHeight: '22px',
    '&$desktop': {
      display: 'flex',
      textAlign: 'center',
    },
  },
  nextAvailableDateLabel: {
    ...typography['Lato Body 2'],
    fontSize: 16,
    fontWeight: 'bold',
    marginRight: '5px',
  },
  nextAvailableDate: {
    ...typography['Lato Emphasized 2'],
    fontSize: 16,
    fontWeight: 'normal',
  },
  defaultPractitionerImage: {
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    padding: '8px',
    '&$desktop': {
      padding: '25px',
    },
  },
  languagesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  flagStyles: {
    marginRight: 8,
  },
  ratingWrapper: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 'fit-content',
  },
  ratingValue: {
    fontSize: 16,
    fontWeight: 700,
    marginLeft: 4,
    marginRight: 8,
  },
  ratingCount: {
    fontSize: 14,
    color: `${theme.palette.grey[600]}`,
  },
  desktop: {},
  selected: {},
  pillSpecialisations: {
    marginTop: 8,
  },
}))
